import { Box, Center, Flex, Heading, Icon, Text } from '@chakra-ui/react';
import { FiCheck } from '@react-icons/all-files/fi/FiCheck';

import { MarketplaceVehicle, formatVehicleTitle } from '../../../../../../utils/cars';
import { formatMoney } from '../../../../../../utils/helpers';
import { AcceptedOffer } from './utils';

type PostAcceptanceHeaderProps = {
  vehicle: MarketplaceVehicle;
  offer?: AcceptedOffer;
};

const PostAcceptanceHeader = ({ vehicle, offer }: PostAcceptanceHeaderProps) => {
  const dealershipName = offer?.orgName;
  const specialistName = offer?.repName;
  const hasDealership = dealershipName != null && dealershipName !== '';
  const hasSpecialist = specialistName != null && specialistName !== '';

  return (
    <Box
      as="section"
      aria-label="Sale confirmed"
      bg="leaseEndBlue"
      borderRadius="16px"
      px={{ base: '20px', md: '32px' }}
      py={{ base: '24px', md: '28px' }}
    >
      <Flex
        direction={{ base: 'column', md: 'row' }}
        justify="space-between"
        align={{ md: 'center' }}
        gap="20px"
      >
        <Flex direction="column" gap="10px">
          <Flex align="center" gap="10px">
            <Center w="24px" h="24px" borderRadius="full" bg="leaseEndGreen">
              <Icon as={FiCheck} boxSize="13px" color="white" strokeWidth="3px" />
            </Center>
            <Text
              fontSize="12px"
              fontWeight="700"
              letterSpacing="0.12em"
              textTransform="uppercase"
              color="greenLight"
              lineHeight="1"
            >
              Sale confirmed
            </Text>
          </Flex>
          <Heading
            as="h1"
            fontFamily="heading"
            fontSize={{ base: '24px', md: '30px' }}
            fontWeight="700"
            color="white"
            lineHeight="1.15"
          >
            Your {formatVehicleTitle(vehicle)} is sold
          </Heading>
          {(hasDealership || hasSpecialist) && (
            <Text fontSize="14px" fontWeight="500" color="placeholderBlue">
              {hasDealership && (
                <>
                  Sold to{' '}
                  <Text as="strong" color="white" fontWeight="600">
                    {dealershipName}
                  </Text>
                </>
              )}
              {hasDealership && hasSpecialist && ' · '}
              {hasSpecialist && <>handled by {specialistName}</>}
            </Text>
          )}
        </Flex>

        {offer && (
          <Flex direction="column" align={{ base: 'flex-start', md: 'flex-end' }} gap="8px">
            <Text
              fontSize="12px"
              fontWeight="600"
              letterSpacing="0.08em"
              textTransform="uppercase"
              color="placeholderBlue"
              lineHeight="1"
            >
              Final sale price
            </Text>
            <Heading
              as="span"
              fontFamily="heading"
              fontSize={{ base: '32px', md: '40px' }}
              fontWeight="800"
              color="leaseEndYellow"
              lineHeight="1"
            >
              {formatMoney(offer.amount)}
            </Heading>
          </Flex>
        )}
      </Flex>
    </Box>
  );
};

export default PostAcceptanceHeader;
